
  import React from 'react'
  import { MDXTag } from '@mdx-js/tag'
  import { Playground } from 'docz';
import State from '../../../../docs/State';
import RadioInput from '@devsisters/ui-careers/lib/RadioInput';

const layoutProps = {
  
};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = null
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             
             components={components}>

<MDXTag name="h1" components={components} props={{"id":"radioinput"}}>{`RadioInput`}</MDXTag>
<MDXTag name="p" components={components}>{`여러 선택지 중에서 하나만 입력받아야 할 경우에 사용합니다.`}</MDXTag>
<MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{"className":"language-tsx"}}>{`import { RadioInput } from '@devsisters/ui/careers';
// 또는 import RadioInput from '@devsisters/ui-careers/lib/RadioInput';
`}</MDXTag></MDXTag>
<MDXTag name="h3" components={components} props={{"id":"놀이터"}}>{`놀이터`}</MDXTag>
<Playground __position={0} __code={'<div style={{ display: \'flex\', justifyContent: \'space-between\' }}>\n  <div>\n    <h2>기본</h2>\n    <State initialState={{ value: \'\' }}>\n      {({ state, setState }) =>\n        [\'a\', \'b\', \'c\'].map(value => (\n          <div key={value}>\n            <RadioInput\n              style={{ fontSize: \'16px\' }}\n              value={value}\n              checked={state.value === value}\n              onChange={value => setState({ value })}\n            />\n          </div>\n        ))\n      }\n    </State>\n  </div>\n  <div>\n    <h2>비활성화</h2>\n    {[\'a\', \'b\', \'c\'].map(value => (\n      <div key={value}>\n        <RadioInput\n          style={{ fontSize: \'16px\' }}\n          value={value}\n          checked={false}\n          disabled\n        />\n      </div>\n    ))}\n  </div>\n  <div>\n    <h2>라벨</h2>\n    <State initialState={{ value: \'\' }}>\n      {({ state, setState }) =>\n        [\'a\', \'b\', \'c\'].map(value => (\n          <div key={value}>\n            <RadioInput\n              style={{ fontSize: \'16px\' }}\n              value={value}\n              checked={state.value === value}\n              onChange={value => setState({ value })}\n              label={value}\n            />\n          </div>\n        ))\n      }\n    </State>\n  </div>\n  <div>\n    <h2>역방향 라벨</h2>\n    <State initialState={{ value: \'\' }}>\n      {({ state, setState }) =>\n        [\'a\', \'b\', \'c\'].map(value => (\n          <div key={value}>\n            <RadioInput\n              style={{ fontSize: \'16px\' }}\n              value={value}\n              checked={state.value === value}\n              onChange={value => setState({ value })}\n              label={value}\n              reverse\n            />\n          </div>\n        ))\n      }\n    </State>\n  </div>\n</div>'} __scope={{props: this ? this.props : props,State,RadioInput}}>
  <div style={{ display: 'flex', justifyContent: 'space-between' }}>
    <div>
      <h2>기본</h2>
      <State initialState={{ value: '' }}>
        {({ state, setState }) => (
          ['a', 'b', 'c'].map(value => <div key={value}>
            <RadioInput
              style={{ fontSize: '16px' }}
              value={value}
              checked={state.value === value}
              onChange={value => setState({ value })}
            />
          </div>)
        )}
      </State>
    </div>
    <div>
      <h2>비활성화</h2>
      {['a', 'b', 'c'].map(value => <div key={value}>
        <RadioInput
          style={{ fontSize: '16px' }}
          value={value}
          checked={false}
          disabled
        />
      </div>)}
    </div>
    <div>
      <h2>라벨</h2>
      <State initialState={{ value: '' }}>
        {({ state, setState }) => (
          ['a', 'b', 'c'].map(value => <div key={value}>
            <RadioInput
              style={{ fontSize: '16px' }}
              value={value}
              checked={state.value === value}
              onChange={value => setState({ value })}
              label={value}
            />
          </div>)
        )}
      </State>
    </div>
    <div>
      <h2>역방향 라벨</h2>
      <State initialState={{ value: '' }}>
        {({ state, setState }) => (
          ['a', 'b', 'c'].map(value => <div key={value}>
            <RadioInput
              style={{ fontSize: '16px' }}
              value={value}
              checked={state.value === value}
              onChange={value => setState({ value })}
              label={value}
              reverse
            />
          </div>)
        )}
      </State>
    </div>
  </div>
</Playground>
           </MDXTag>
  }
}
  